document.addEventListener('DOMContentLoaded', function() {
    const rightArrow = document.querySelector('.right-arrow');
    if (rightArrow) {
        rightArrow.addEventListener('click', function() {
            const carousel = document.querySelector('.carousel-wrapper');
            // Check if carousel exists and console log its current scroll position
            if (carousel) {
                console.log('Current scroll position:', carousel.scrollLeft);
                carousel.scrollLeft += 300; // Adjust as necessary
                console.log('New scroll position:', carousel.scrollLeft);
            }
        });
    }
});
